import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ControleSeapService {

  baseUrl = 'controle-seap/'

  constructor(private db: AngularFireDatabase, private toastr: ToastrService) {
  }

  insertCurso(curso, id): any {
    if (id) return this.db.database.ref(`${this.baseUrl}cursos/${id}`).update(curso).then(() => true);
    return this.db.database.ref(`${this.baseUrl}cursos`).push(curso);
  }

  getCursos() {
    return this.db.list(`${this.baseUrl}cursos`).valueChanges();
  }
  getCursoById(id) {
    return this.db.database.ref(`${this.baseUrl}cursos/${id}`).once('value');
  }

  getCursosStatic() {
    return this.db.database.ref(`${this.baseUrl}cursos`).once('value');
  }

  removeCursoById(id) {
    return this.db.database.ref(`${this.baseUrl}cursos/${id}`).remove().then(() => true);
  }

  insertMatricula(matricula, id): any {
    if (id) return this.db.database.ref(`${this.baseUrl}matriculas/${id}`).update(matricula).then(() => true);
    return this.db.database.ref(`${this.baseUrl}matriculas`).push(matricula);
  }

  getMatriculas() {
    return this.db.list(`${this.baseUrl}matriculas`).valueChanges();
  }
  getMatriculasConcluidas() {
    return this.db.list(`${this.baseUrl}matriculasConcluidas`).valueChanges();
  }
  getMatriculaById(id) {
    return this.db.database.ref(`${this.baseUrl}matriculas/${id}`).once('value');
  }

  getMatriculasStatic() {
    return this.db.database.ref(`${this.baseUrl}matriculas`).once('value');
  }

  getMatriculasConcluidasStatic() {
    return this.db.database.ref(`${this.baseUrl}matriculasConcluidas`).once('value');
  }

  removeMatriculaById(id) {
    return this.db.database.ref(`${this.baseUrl}matriculas/${id}`).remove().then(() => true);
  }

  changeEntregue(id, value) {
    return this.db.database.ref(`${this.baseUrl}matriculas/${id}`).update({entregue: value}).then(() => true);
  }

  changeRecolhido(id, value) {
    return this.db.database.ref(`${this.baseUrl}matriculas/${id}`).update({recolhida: value}).then(() => true);
  }

  concluirMatricula(mat) {
    return this.db.database.ref(`${this.baseUrl}matriculasConcluidas/${mat.id}`).set(mat).then(() => true);
  }

  restaurarMatricula(mat) {
    let aux = mat.startDate.split('/');
    mat.startDate = `${aux[2]}-${aux[1]}-${aux[0]}`;
    aux = mat.endDate.split('/');
    mat.endDate = `${aux[2]}-${aux[1]}-${aux[0]}`;
    return this.db.database.ref(`${this.baseUrl}matriculas/${mat.id}`).set(mat).then(() => true);
  }

  removeMatriculaConcluidaById(id) {
    return this.db.database.ref(`${this.baseUrl}matriculasConcluidas/${id}`).remove().then(() => true);
  }

  

  addArrayMatricula(arr) {
    const p = []
    for(const x in arr) {
      if(arr[x]){
        console.log("Fazendo ", x);
        p.push(new Promise(resolve => {resolve(this.db.database.ref(`${this.baseUrl}matriculas`).push(arr[x])) }));
      }
    }
    return Promise.all(p).then(res => {
      this.toastr.success(`${arr.length} matrículas foram computadas!`);
    }).catch(err => {

      this.toastr.error(`Ocorreu um erro em alguma das matrículas informadas, verifique e tente novamente!`);
    });
  }



}